import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cangkuguanli",
  "use": "icon-cangkuguanli-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-cangkuguanli\"><path d=\"M14.49 7.495a.499.499 0 01-.323-.118L7.994 2.139 1.819 7.377a.5.5 0 01-.647-.763L7.67 1.102a.501.501 0 01.647 0l6.499 5.512a.5.5 0 01-.325.881zm-1.148 7.483H2.647a.656.656 0 01-.655-.655V6.39a.5.5 0 111 0v7.588h10.005V6.389a.5.5 0 111 0v7.934a.657.657 0 01-.655.655zm-2.345-2.497H4.992a.5.5 0 110-1h6.005a.5.5 0 110 1zm0-1.997H4.992a.5.5 0 110-1h6.005a.5.5 0 110 1zm0-1.984H4.992a.5.5 0 110-1h6.005a.5.5 0 110 1z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/cangkuguanli.svg
// module id = 450
// module chunks = 4